<template>
  <div>
    <v-row>
      <v-col cols="12" align="center">
        <img height="35px" src="../../../assets/logo.png" />
      </v-col>
      <v-col cols="12" align="center">
        <h4 class="h4-header mt-2">{{ $t("labels.forgotPassword") }}</h4>
        <div class="mt-2">{{ $t("labels.forgotPasswordSubtitle") }}</div>
      </v-col>
      <v-col cols="12">
        <v-text-field
          outlined
          dense
          v-model.trim="email"
          :error-messages="emailErrors"
          :hide-details="emailErrors.length === 0"
          :label="$t('labels.email')"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-card-actions class="mb-0">
      <v-btn text to="/login">Sign In</v-btn>
      <v-spacer> </v-spacer>
      <v-btn @click="submit" color="primary" large>{{ $t("buttons.reset") }}</v-btn>
    </v-card-actions>

    <v-layout class="mt-4" row justify-space-between="justify-space-between"> </v-layout>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import publicService from "../../../api/public";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  data() {
    return {
      email: null
    };
  },
  created() {
    if (this.$route.query) {
      this.email = this.$route.query.email;
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toasted.error("Invalid Input", {
          position: "top-right",
          showHideTransition: "slide",
          duration: 2000
        });
      } else {
        this.$Progress.start();
        publicService
          .resetPassword({
            email: this.email
          })
          .then(response => {
            if (response.status) {
              this.$Progress.finish();
              // set the organization id or ask for the selection
              this.$swal("Reset Password", "Email was send successfully ", "success").then(() => {
                this.$router.push({ path: "/login" });
              });
            } else {
              this.$swal("Reset Password", "Check email and try again", "error");
            }
          })
          .catch(error => {
            this.$Progress.finish();
            console.log(error);
            this.$swal("Reset Password", "Check email and try again", "error");
          });
      }
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required.");
      return errors;
    }
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required
    }
  }
};
</script>
